// extracted by mini-css-extract-plugin
export default {"text":"StepTitle_text__NYxhB"};